import { render, staticRenderFns } from "./VesselMachine.vue?vue&type=template&id=12ab14f5&scoped=true&"
import script from "./VesselMachine.vue?vue&type=script&lang=js&"
export * from "./VesselMachine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab14f5",
  null
  
)

export default component.exports